import { Link, TableCellText } from "@ceridianhcm/components";
import { FileTypeDisplayName, SubmissionTypeDisplayName, IsProduction, Status } from "../../models/StandAloneData";
import { FormatFullDate } from "../../common/formatting";

const CellText = ({ text }: { text: string | number }) => (
  <TableCellText>
    <div title={String(text)}>
      {text}
    </div>
  </TableCellText>
);

export const useYearEndColumnsDefinitions = (onClickFileName, fileTypeLookup: Record<string, string> = {}, submissionTypeLookup: Record<string, string> = {}) => {
  return [
    {
      field: "importId",
      label: "Import ID",
      cellTemplate: (cellContext: any) => <CellText text={cellContext.rowData.importId ?? ''} />,
    },
    {
      field: "T4companyName",
      label: "Company Name",
      cellTemplate: (cellContext: any) => <CellText text={cellContext.rowData.T4companyName || cellContext.rowData.companyName} />,
    },
    {
      field: "T4companyId",
      label: "Company ID",
      cellTemplate: (cellContext: any) => {
        const companyId = (cellContext.rowData.T4companyId || cellContext.rowData.companyId)?.slice(1);
        return <CellText text={companyId} />;
      },
    },
    {
      field: "T4fileName",
      label: "File Name",
      cellTemplate: (cell: any) => {
        const fileName = cell.rowData.T4fileName || cell.rowData.fileName;
        return (
          <Link
            id={`name-${cell.rowData.T4fileName}`}
            onClick={() => onClickFileName(cell.rowData)}
            variant="neutral"
            testId={`name-${cell.rowData.T4fileName}`}
          >
            <div title={fileName}>{fileName}</div>
          </Link>
        );
      }
    },
    {
      field: "T4fileType",
      label: "File Type",
      cellTemplate: (cellContext: any) => {
        const fileTypeValue = cellContext.rowData.T4fileType ?? cellContext.rowData.fileType;
        const fileTypeId = String(fileTypeValue);
        const fileTypeDescription = fileTypeLookup[fileTypeId] || FileTypeDisplayName[fileTypeValue] || 'Unknown';
        return <CellText text={fileTypeDescription} />;
      },
    },
    {
      field: "T4status",
      label: "Status",
      cellTemplate: (cellContext: any) => <CellText text={Status[cellContext.rowData.T4status ?? cellContext.rowData.status]} />,
    },
    {
      field: "submissionType",
      label: "Submission Type",
      cellTemplate: (cellContext: any) => {
        const submissionTypeId = String(cellContext.rowData.submissionType ?? 0);
        const description = submissionTypeId === '0' ? '' : (submissionTypeLookup[submissionTypeId] || SubmissionTypeDisplayName[submissionTypeId] || submissionTypeId);
        return <CellText text={description} />;
      },
    },
    {
      field: "T4isProduction",
      label: "Prod/Test",
      cellTemplate: (cellContext: any) => <CellText text={IsProduction[cellContext.rowData.T4isProduction ?? cellContext.rowData.isProduction]} />,
    },
    {
      field: "T4createdOn",
      label: "Created Date",
      cellTemplate: (cellContext: any) => <CellText text={FormatFullDate(cellContext.rowData.T4createdOn ?? cellContext.rowData.createdOn)} />,
    }   
  ];
};